import React from "react";

export const Divider = () => {
  return (
    <div
      style={{
        backgroundColor: "#E4E4ED",
        height: 1,
        width: "100%",
        marginBottom: 20,
      }}
    />
  );
};

export default Divider;
